<template>
    <div class="product-item-small" :class="{ 'effect': effect }">
        <div class="product-item-in-small blurred pe-none">
            <div class="card h-100 product-item product-item-short p-0 border-0 d-flex flex-column text-center text-decoration-none">
                <div class="ratio ratio-1x1 product-thumb-header small bg-black d-flex justify-content-center align-items-center position-relative w-100 flex-shrink-0">
                    <div class="p-4 product-thumb-img">
                        <ProductImage :product="product" :small="false" />
                    </div>

                    <div class="position-absolute top-0 end-0 m-2 me-0 mt-0">
                        <WatchlistButton :product_id="product.id" />
                    </div>
                </div>

                <div class="product-thumb-body p-3 d-flex flex-column flex-grow-1 bg-grey">
                     <span
                         class="card-title clamp-2 mb-2 fw-bold text-uppercase"
                         :title="product.name"
                     >
                        XXXXXXXXXX
                    </span>

                    <p class="card-text mb-2 placeholder-glow">
                        <span class="placeholder col-4">XXXXXXX</span>
                    </p>

                    <button
                        v-if="product.shop_availability"
                        class="btn btn-outline-primary btn-sm w-100 mt-auto"
                    >
                        {{ $t('products.add_to_cart') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const ProductImage = defineAsyncComponent(() => import('~/components/Product/ProductImage.vue'));
const WatchlistButton = defineAsyncComponent(() => import('~/components/Product/Buttons/WatchlistButton.vue'));


const props = defineProps({
    effect: Boolean,
    image: String,
});

const product = {
    id: -1,
    url: '#',
    name: '',
    images: {fallback: props.image},
    shop_availability: true,
    gross_price: 1000.99,
};
</script>
